export var CustomerTypeValues = ['corporation', 'individual'];
export var StoreTypeValues = ['company', 'home', 'other'];
export var BusinessTypeValues = ['wholesale', 'retail', 'both'];
export var CommunityEngagementValues = [
    'none',
    'endorsing',
    'collaborating',
    'comrade',
];
export var TradeCounties = [
    'YE',
    'IN',
    'ID',
    'UG',
    'EC',
    'ET',
    'SV',
    'CM',
    'CU',
    'GT',
    'KE',
    'CR',
    'CO',
    'CD',
    'JM',
    'TH',
    'TW',
    'TZ',
    'CN',
    'DO',
    'NI',
    'PA',
    'PG',
    'TL',
    'BR',
    'BI',
    'VN',
    'PE',
    'BO',
    'HN',
    'MW',
    'MM',
    'MX',
    'LA',
    'RW',
];
export var TradeCountryUsages = [
    'filter',
    'espresso',
    'omniroast',
    'blend_component',
];
export var TradeCountryProcessings = [
    'washed',
    'honey',
    'natural',
    'washed_anaerobic',
    'natural_anaerobic',
    'experimental',
];
export var TradeCountryPriceRanges = [
    '5_to_10_dollars',
    '10_to_15_dollars',
    '15_to_20_dollars',
    '20_to_30_dollars',
    '30_dollars_or_more',
];
export var JP_PREFECTURES = [
    '北海道',
    '青森県',
    '岩手県',
    '宮城県',
    '秋田県',
    '山形県',
    '福島県',
    '茨城県',
    '栃木県',
    '群馬県',
    '埼玉県',
    '千葉県',
    '東京都',
    '神奈川県',
    '新潟県',
    '富山県',
    '石川県',
    '福井県',
    '山梨県',
    '長野県',
    '岐阜県',
    '静岡県',
    '愛知県',
    '三重県',
    '滋賀県',
    '京都府',
    '大阪府',
    '兵庫県',
    '奈良県',
    '和歌山県',
    '鳥取県',
    '島根県',
    '岡山県',
    '広島県',
    '山口県',
    '徳島県',
    '香川県',
    '愛媛県',
    '高知県',
    '福岡県',
    '佐賀県',
    '長崎県',
    '熊本県',
    '大分県',
    '宮崎県',
    '鹿児島県',
    '沖縄県',
];
